/**
 * Config export formats (CAL-6126) - the transport side only. WHICH formats
 * apply to the whole config and to each table is decided server-side and
 * arrives, already ordered, as the `exports` catalog of
 * `GET /integrations/{id}/config-schema/`; the menu copy lives with the menu.
 */

export type ConfigExportFormat = "xlsx" | "csv" | "json";

/** Per-format export availability, as served next to the config schema. */
export interface ConfigExportCatalog {
  /** Formats for the whole config, in menu order. */
  config: ConfigExportFormat[];
  /** Formats per top-level field key (only fields that export at all). */
  fields: Record<string, ConfigExportFormat[]>;
}

interface ConfigExportTransport {
  /** File extension of the fallback name when Content-Disposition is unreadable. */
  ext: string;
  /**
   * Request `Accept` header. A binary body through API Gateway is decoded
   * only when the first Accept value is one of its BinaryMediaTypes, so xlsx
   * (served as `application/octet-stream`) must ask for exactly that.
   */
  accept?: string;
}

export const CONFIG_EXPORT_FORMATS: Record<
  ConfigExportFormat,
  ConfigExportTransport
> = {
  xlsx: { ext: "xlsx", accept: "application/octet-stream" },
  csv: { ext: "csv" },
  json: { ext: "json" },
};
